(function () {
  const CONFIG_ID = 'densia-one-month-atc-config'

  const getConfig = () => {
    const el = document.getElementById(CONFIG_ID)
    if (!el) return null
    try {
      return JSON.parse(el.textContent)
    } catch {
      return null
    }
  }

  const clickKachingOneMonth = (dealId) => {
    const selectors = dealId
      ? [
          `.kaching-bundles__bar[data-deal-bar-id="${dealId}"] .kaching-bundles__bar-main`,
          `.kaching-bundles__bar[data-deal-bar-id="${dealId}"]`,
        ]
      : [
          '.kaching-bundles__bar:first-child .kaching-bundles__bar-main',
          '.kaching-bundles__bar:first-child',
        ]

    for (const selector of selectors) {
      const target = document.querySelector(selector)
      if (target) {
        target.click()
        return true
      }
    }

    return false
  }

  const submitPdpForm = (config) => {
    const form = document.querySelector(config.pdpFormSelector || '')
    if (!form) return false

    const idInput = form.querySelector('input[name="id"]')
    if (idInput && config.variantId) {
      idInput.value = String(config.variantId)
    }

    clickKachingOneMonth(config.kachingDealId)

    const submitBtn =
      form.querySelector('.densia-pdp__cta-btn') ||
      form.querySelector('button[type="submit"][name="add"]') ||
      form.querySelector('button[type="submit"]')

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(submitBtn || undefined)
    } else if (submitBtn) {
      submitBtn.click()
    } else {
      form.submit()
    }

    return true
  }

  const openCartDrawer = () => {
    const drawer = document.getElementById('cart-drawer')
    if (drawer && typeof drawer.show === 'function') {
      drawer.show()
    }
  }

  const addViaAjax = async (config) => {
    const root = window.Shopify?.routes?.root || '/'
    const item = {
      id: Number(config.variantId),
      quantity: 1,
    }

    if (config.sellingPlanId) {
      item.selling_plan = Number(config.sellingPlanId)
    }

    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items: [item] }),
    })

    const payload = await response.json()
    if (!response.ok) {
      throw new Error(payload.description || 'Unable to add to cart')
    }

    const cart = await (await fetch(`${root}cart.js`)).json()

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          cart,
        },
      })
    )

    openCartDrawer()
  }

  const handleOneMonthAtc = async (button) => {
    const config = getConfig()
    if (!config?.variantId) return

    if (button.getAttribute('aria-busy') === 'true') return
    button.setAttribute('aria-busy', 'true')

    try {
      const usedPdpForm = submitPdpForm(config)
      if (!usedPdpForm) {
        await addViaAjax(config)
      }
    } catch (error) {
      console.error('[densia-one-month-atc]', error)
    } finally {
      button.removeAttribute('aria-busy')
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-densia-one-month-atc]')
    if (!button) return

    event.preventDefault()
    void handleOneMonthAtc(button)
  })
})()
